/**
 * String canônica assinada. DEVE ser byte-a-byte igual ao backend:
 * método \n urlComParams \n nonce
 */
export function buildCanonical(
  method: string,
  urlWithParams: string,
  nonce: string
): string {
  return [method.toUpperCase(), urlWithParams, nonce].join('\n');
}
